import Reveal from "@/components/Reveal";
import { manifestoChapters } from "@/data/siteData";

export default function ManifestoSection() {
  return (
    <section className="manifesto-section" id="manifesto" data-testid="manifesto-section">
      <div className="section-shell manifesto-layout">
        <Reveal className="manifesto-intro" delay={80}>
          <div className="eyebrow"><span className="eyebrow__dot" /> 03 / Our manifesto</div>
          <h2>We do not just clean.<br /><em>We transform.</em></h2>
          <p>Our promise is not a slogan on the wall. It is the feeling that remains when we leave.</p>
          <div className="manifesto-quote">“The highest standard is the one your guest never has to notice.”</div>
        </Reveal>
        <div className="manifesto-chapters">
          {manifestoChapters.map((chapter, index) => <Reveal as="article" className="manifesto-chapter" delay={120 + index * 90} key={chapter.number} data-testid={`manifesto-chapter-${chapter.number}`}>
            <span className="manifesto-chapter__number">{chapter.number}</span>
            <div><h3>{chapter.title}</h3><p>{chapter.text}</p></div>
          </Reveal>)}
        </div>
      </div>
    </section>
  );
}
